export default __webpack_public_path__ + "static/media/radio.73149bfc.svg";